import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import FacilityMarker from './FacilityMarker';

export function FacilityMarkers({
	facilities, highlightedFacility, phone, getLocalPhoneNumberByZipCode,
	preselectedFacilityId
}) {
	return (
		<div>
			{map(facilities, (facility, index) => (
				<FacilityMarker
					position={facility.location}
					key={facility.id}
					offsetY={0}
					zIndex={index}
					facility={facility}
					phone={phone}
					getLocalPhoneNumberByZipCode={getLocalPhoneNumberByZipCode}
					highlighted={facility.id === highlightedFacility || facility.id === preselectedFacilityId}
					isPreselectedFacility={facility.id === preselectedFacilityId}
				/>
			))}
		</div>);
}

FacilityMarkers.propTypes = {
	getLocalPhoneNumberByZipCode: PropTypes.func,
	facilities: PropTypes.arrayOf(PropTypes.object),
	highlightedFacility: PropTypes.number,
	phone: PropTypes.object,
	preselectedFacilityId: PropTypes.number
};


export default FacilityMarkers;
